import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { track } from "../lib/analytics";
import { useSettings } from "../context/SettingsContext";
import { artistSchema, websiteSchema } from "../lib/schema";
import Seo from "../components/Seo";
import Hero from "../components/Hero";
import StreamingBar from "../components/StreamingBar";
import FeaturedRelease from "../components/FeaturedRelease";
import FollowFavorite from "../components/FollowFavorite";
import UpcomingReleases from "../components/UpcomingReleases";
import Manifesto from "../components/Manifesto";
import SectionGrid from "../components/SectionGrid";
import VideosSection from "../components/VideosSection";
import SocialSection from "../components/SocialSection";
import EmailCapture from "../components/EmailCapture";
import FanPoll from "../components/FanPoll";
import { SocialGrid, NewsTeaser } from "../components/ContentBlocks";
import Footer from "../components/Footer";

export default function Home() {
  const settings = useSettings();
  const [campaign, setCampaign] = useState(null);
  const [featured, setFeatured] = useState(null);
  const [releases, setReleases] = useState([]);
  const [videos, setVideos] = useState([]);
  const [upcoming, setUpcoming] = useState([]);

  useEffect(() => {
    track("page_view", {});
    Promise.all([
      api.get("/campaigns/active"),
      api.get("/releases/featured"),
      api.get("/releases"),
      api.get("/videos"),
      api.get("/releases/upcoming"),
    ]).then(([c, f, r, v, u]) => {
      setCampaign(c.data);
      setFeatured(f.data);
      setReleases(r.data || []);
      setVideos(v.data || []);
      setUpcoming(u.data || []);
    }).catch(() => {});
  }, []);

  const featuredId = featured?.internalId;
  const singles = releases.filter((r) => r.internalId !== featuredId);
  const albums = releases.filter((r) => r.releaseType === "album");

  return (
    <div className="grain relative">
      <Seo
        path="/"
        type="music.musician"
        description={settings?.bioShort}
        jsonLd={[artistSchema(settings), websiteSchema(settings)]}
      />
      <Hero
        genreLine={settings?.genreLine}
        tagline={settings?.tagline}
        image={settings?.artistImage}
        featured={featured}
        campaign={campaign}
        spotifyArtistUrl={settings?.streaming?.spotify}
      />
      <StreamingBar streaming={settings?.streaming} />
      <FeaturedRelease release={featured} />
      <FollowFavorite settings={settings} />
      <UpcomingReleases releases={upcoming} />
      <Manifesto />
      <SectionGrid id="latest-releases" testId="latest-releases" overline="Música" title="Latest Releases" releases={singles} />
      <SectionGrid id="albums" testId="albums-section" overline="Full Projects" title="Albums" releases={albums} />
      <VideosSection videos={videos} />
      <NewsTeaser />
      <FanPoll />
      <SocialGrid />
      <SocialSection socials={settings?.socials} />
      <EmailCapture />
      <Footer settings={settings} />
    </div>
  );
}
